import { DateTimeBox } from '@apply/components';
import { useState } from 'react';

export const DateTimeBoxDemo: React.FC = () => {
    const [dateBoxWithTime, set_dateBoxWithTime] = useState<string>('');
    const [dateBoxWithoutTime, set_dateBoxWithoutTime] = useState<string>('');
    const [dateBoxWithoutTimeWithBubble, set_dateBoxWithoutTimeWithBubble] = useState<string>('');

    return (
        <>
            <h2>Date Time Box :</h2>
            <br />
            <DateTimeBox
                required={true}
                value={dateBoxWithTime}
                onChange={(value) => set_dateBoxWithTime(value)}
                label='DateTimeBox Showing Time'
                includeTime={true}
            />
            <br />
            <DateTimeBox
                required={true}
                value={dateBoxWithoutTime}
                onChange={(value) => set_dateBoxWithoutTime(value)}
                label='DateTimeBox Without Time'
                includeTime={false}
            />
            <br />
            <DateTimeBox
                required={true}
                value={dateBoxWithoutTimeWithBubble}
                onChange={(value) => set_dateBoxWithoutTimeWithBubble(value)}
                label='DateTimeBox Without Time With Bubble'
                includeTime={false}
                showInfoIcon={true}
                infoText='DateTimeBox Without Time With Bubble'
            />
        </>
    );
};
